import { render, staticRenderFns } from "./QuestionRecommendations.vue?vue&type=template&id=31e8f843&scoped=true"
import script from "./QuestionRecommendations.vue?vue&type=script&lang=js"
export * from "./QuestionRecommendations.vue?vue&type=script&lang=js"
import style0 from "./QuestionRecommendations.vue?vue&type=style&index=0&id=31e8f843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8f843",
  null
  
)

export default component.exports